// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconCheckmark = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M54.8493 19.791L29.5252 45.1152C28.7616 45.8787 27.8138 45.8787 27.0503 45.1152L13.1508 31.2157C12.3872 30.4521 12.3872 29.5044 13.1508 28.7408L16.5268 25.3648C17.3479 24.5437 18.3372 24.5816 19.0929 25.4634L28.2878 37.1906L48.9016 13.9422C49.6607 13.1198 50.6335 13.1003 51.4249 13.8918L54.8493 17.3162C55.6129 18.0797 55.6129 19.0275 54.8493 19.791Z" />
    </svg>
  );
};
